import {
  signalHintSourceLabel,
  vehicleContextLabel,
  type SignalHint
} from '../../lib/decode/signalHints';

type SignalHintCardProps = {
  hints: SignalHint[];
};

function formatFactorOffset(hint: SignalHint) {
  const parts = [];
  if (typeof hint.factor === 'number') parts.push(`factor ${hint.factor}`);
  if (typeof hint.offset === 'number') parts.push(`offset ${hint.offset}`);
  return parts.join(' / ');
}

export function SignalHintCard({ hints }: SignalHintCardProps) {
  if (hints.length === 0) {
    return (
      <article className="signal-graph-hint empty">
        <p className="eyebrow">Signal hint</p>
        <h3>No catalog hint found for this CAN ID yet.</h3>
        <p>Seeded matches are suggestions, not verified decodes.</p>
      </article>
    );
  }

  return (
    <div className="signal-graph-hints">
      {hints.slice(0, 4).map((hint) => (
        <article className="signal-graph-hint" key={hint.id}>
          <div className="contribution-card-heading">
            <div>
              <p className="eyebrow">{signalHintSourceLabel(hint)}</p>
              <h3>{hint.signalName}</h3>
            </div>
            <span className="signal-hint-badge">{hint.confidenceLabel ?? `${Math.round(hint.confidence * 100)}%`}</span>
          </div>
          {hint.description && <p>{hint.description}</p>}
          <div className="signal-meta-row">
            {hint.unit && <span>Unit: {hint.unit}</span>}
            {formatFactorOffset(hint) && <span>{formatFactorOffset(hint)}</span>}
            {hint.messageName && <span>Message: {hint.messageName}</span>}
          </div>
          {vehicleContextLabel(hint) && <p className="panel-note">Context: {vehicleContextLabel(hint)}</p>}
        </article>
      ))}
      {hints.length > 4 && <p className="panel-note">Showing 4 of {hints.length.toLocaleString()} matching hints for this CAN ID.</p>}
    </div>
  );
}
